import { render, staticRenderFns } from "./ConfigurationCrudView.vue?vue&type=template&id=af960cae&"
import script from "./configurationCrudView.js?vue&type=script&lang=js&"
export * from "./configurationCrudView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports